import React, {createContext, useState, useEffect, useContext} from "react"

// Context'i oluşturuyoruz
const LanguageContext = createContext()

// Context provider'ı
export const LanguageProvider = ({children}) => {
  const [language, setLanguage] = useState(null)
  const [languageId, setLanguageId] = useState(null)

  useEffect(() => {
    // Local storage'dan dil ve id bilgisini alıyoruz
    const loadLanguage = () => {
      const savedLanguage = localStorage.getItem("language")
      const savedLanguageId = localStorage.getItem("languageId")

      if (savedLanguage && savedLanguageId) {
        setLanguage(savedLanguage)
        setLanguageId(savedLanguageId)
      } else {
        // Eğer dil ya da ID kaydedilmemişse, varsayılan dil 'TR' ve ID '3' olarak ayarlanır
        const defaultLanguage = "TR"
        const defaultLanguageId = "3" // Example: Default TR language ID
        setLanguage(defaultLanguage)
        setLanguageId(defaultLanguageId)
        localStorage.setItem("language", defaultLanguage)
        localStorage.setItem("languageId", defaultLanguageId)
      }
    }
    loadLanguage()
  }, [])

  // Dil değiştirme fonksiyonu
  const changeLanguage = (newLanguage, newLanguageId) => {
    setLanguage(newLanguage)
    setLanguageId(newLanguageId)
    localStorage.setItem("language", newLanguage) // Store new language in localStorage
    localStorage.setItem("languageId", newLanguageId) // Store new language ID in localStorage
  }

  return (
    <LanguageContext.Provider value={{language, languageId, changeLanguage}}>
      {children}
    </LanguageContext.Provider>
  )
}

// Context kullanımı için custom hook
export const useLanguage = () => useContext(LanguageContext)
